import { render, staticRenderFns } from "./SwipeItem.vue?vue&type=template&id=dce4c068&scoped=true"
import script from "./SwipeItem.vue?vue&type=script&lang=js"
export * from "./SwipeItem.vue?vue&type=script&lang=js"
import style0 from "./SwipeItem.vue?vue&type=style&index=0&id=dce4c068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce4c068",
  null
  
)

export default component.exports